import appLogger from "./appLogger";
const VALID_MODULE_NAME_PATTERN = /^[A-Za-z0-9_.-]+$/;
const createModuleLogger = (moduleName) => {
    if (!VALID_MODULE_NAME_PATTERN.test(moduleName)) {
        appLogger.error(`createModuleLogger: invalid module name "${moduleName}". Use letters, digits, "_", "." or "-" only.`);
    }
    return appLogger.withTag(`module=${moduleName}`);
};
export default createModuleLogger;
